import React, { Component } from 'react'
import { connect } from 'react-redux'
import { AccessOverview as AccessOverview23 } from 'projects/flow-gui-access/views/2.3/access'
import { AccessOverview as AccessOverview24 } from 'projects/flow-gui-access/views/2.4/access'

class AccessOverview extends Component {
  render () {
    if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'accesses' && endpoint.version === '2.4').length !== 0) {
      return <AccessOverview24 {...this.props} />
    } else if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'accesses' && endpoint.version === '2.3').length !== 0) {
      return <AccessOverview23 {...this.props} />
    } else return false
  }
}

export default connect(state => state)(AccessOverview)



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/middlewares/access/overview.js